/**
 * Legacy framer-motion variants kept for back-compat with code that still
 * imports `staggerContainer` / `fadeInUp` directly. New code should use the
 * `<Stagger>` and `<RevealItem>` components from `./primitives` instead.
 *
 * @deprecated Phase A.2 — Migrate to the primitives module.
 */

import { motionDuration, motionEase } from './tokens'

export const staggerContainer = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.1,
    },
  },
}

export const fadeInUp = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: motionDuration.base,
      ease: motionEase.out,
    },
  },
}
